// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../utils/codecUtils.schema';
import { integrationCredentialSecretSchema } from '../models/integrationCredential.schema';

export const patchIntegrationCredentialPayloadSchema = z.object({
  name: z.string().optional(),
  secret: integrationCredentialSecretSchema.optional(),
  organization: urlSchema.optional(),
});
